import React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

interface Props {
  children: React.ReactNode;
}

const Provider = DndProvider as React.FC<
  React.PropsWithChildren<{ backend: any; key?: number }>
>;

export const GlobalDndProvider = ({ children }: Props) => {
  return (
    <Provider backend={HTML5Backend} key={1}>
      {children}
    </Provider>
  );
};

export default GlobalDndProvider;
